import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getStorage, connectStorageEmulator } from 'firebase/storage'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)
export const functions = getFunctions(app)

// Use emulador em desenvolvimento (apenas se VITE_USE_EMULATORS=true)
// Para usar emuladores, defina VITE_USE_EMULATORS=true no arquivo .env
// E certifique-se de que os emuladores estão rodando: npm run firebase:emulators
if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === 'true') {
  // Conectar aos emuladores apenas se não estiverem já conectados
  // Verificar se já está conectado verificando a URL do auth
  const authUrl = (auth as any).config?.emulator?.url
  if (!authUrl) {
    try {
      connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
    } catch (e) {
      console.warn('Não foi possível conectar ao Auth Emulator:', e)
    }
  }
  
  try {
    if (!(db as any)._settings?.host?.includes('localhost')) {
      connectFirestoreEmulator(db, 'localhost', 8080)
    }
  } catch (e) {
    console.warn('Não foi possível conectar ao Firestore Emulator:', e)
  }
  
  try {
    connectFunctionsEmulator(functions, 'localhost', 5001)
  } catch (e) {
    console.warn('Não foi possível conectar ao Functions Emulator:', e)
  }
  
  try {
    connectStorageEmulator(storage, 'localhost', 9199)
  } catch (e) {
    console.warn('Não foi possível conectar ao Storage Emulator:', e)
  }
}

export default app

